import { Component, OnInit } from '@angular/core';
import { Company } from '../../classes/company';
import { Department } from '../../classes/department';
import { DepartmentService } from '../../services/department.service';
import { CompanyService } from '../../services/company.service';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-department-page',
  templateUrl: './department-page.component.html',
  styleUrls: ['./department-page.component.scss']
})
export class DepartmentPageComponent implements OnInit {

  constructor(
    private DepartmentService: DepartmentService,
    private route: ActivatedRoute,
    private titleService: Title,
    private CompanyService: CompanyService,
    private UserService: UserService,
    private router: Router
  ) { }

  departments: Department[] = [];
  department: Department = <Department>{};
  company: Company = <Company>{};
  edit: boolean[] = [];
  editing: boolean[] = [];
  sub: any;
  orgId: number;
  adding: boolean;
  error: string;
  openCreateDepartment: boolean;
  nameFocus: boolean = false;
  codeFocus: boolean = false;
  focus: any[] = [];
  isAdmin: boolean = false;

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      let errId: number = +params['errId'];
      if (errId == 1) {
        this.error = 'You cannot go to next step until current step is finished.'
      }
      this.getDepartments();
      this.CompanyService.getCompany(this.orgId)
        .subscribe(org => {
          this.company = JSON.parse(org.organization || '{}');
          let steps = JSON.parse(org.steps || '{}');
          let incomplete: boolean = steps.slice(0, 1).some((s) => {
            return !s[2];
          })
          if (incomplete) {
            this.router.navigate(['/onboarding/user/add/', this.orgId, 1])
          }

        }, err => {
          console.log(err)
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
        })
    });
    this.titleService.setTitle('Departments');

    this.UserService.getUserInfo()
      .subscribe(user => {
        console.log(user)
        let u: any = JSON.parse(user.user);
        this.isAdmin = u.admin;
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  getDepartments() {
    this.DepartmentService.getDepartments(this.orgId)
      .subscribe(deps => {
        this.departments = JSON.parse(deps.departments || '[]');
        this.edit = this.departments.map(d => {
          return false;
        });
        this.editing = JSON.parse(JSON.stringify(this.edit));
        this.focus = this.departments.map(d => {
          return {
            nameFocus: false,
            codeFocus: false
          };
        });
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  addDepartment(departmentForm: NgForm) {
    this.adding = true;
    if (departmentForm.invalid) {
      return;
    }
    this.DepartmentService.addDepartment(this.orgId, this.department)
      .subscribe(deps => {
        this.adding = false;
        departmentForm.reset();
        this.department = <Department>{};
        this.getDepartments();
        this.openCreateDepartment = false;
        if(!this.isAdmin) window.analytics.track("Self-Signup Department Added", {OrgId: this.orgId});
      }, err => {
        console.log(err)
        if(!this.isAdmin) window.analytics.track("Self-Signup Department Addition Failed", {OrgId: this.orgId, reason: err._body});
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  editDepartment(index: number) {
    this.edit[index] = true;
  }

  removeDepartment(id: number) {
    this.DepartmentService.deleteDepartment(this.orgId, id)
      .subscribe(deps => {
        this.getDepartments();
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  complete(id: number, index: number, departmentForm: NgForm, dep: Department) {
    this.editing[index] = true;
    if (departmentForm.valid) {
      this.DepartmentService.editDepartment(this.orgId, id, dep)
        .subscribe(deps => {
          this.editing[index] = false;
          this.getDepartments();
        }, err => {
          console.log(err)
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
        })
    }

  }

  cancel(index: number) {
    this.getDepartments();
  }

  showError() {
    this.error = 'Please complete this form before proceeding.';
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/department-page/department-page.component.ts